import { Scorecard } from '../../scorecard/scorecard-next.model';
import { ScorecardDto } from '../../scorecard/scorecard.model';

import { HistoryPosition } from './history-position.model';

export function createHistoryPosition(
    history: ScorecardDto[],
    currentScorecard: Scorecard,
): HistoryPosition {
    try {
        const index = history.indexOf(currentScorecard.header);
        const isAtFirst = index === 0;
        const isAtLast = index === history.length - 1;
        return {
            index,
            isAtFirst,
            isAtLast,
        };
    } catch {
        return {};
    }
}
